var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ar-volume"},[_c('icon-button',{staticClass:"ar-volume__icon",attrs:{"name":"volume"}}),_vm._v(" "),_c('line-control',{staticClass:"ar-volume-bar",attrs:{"ref-id":"volume","percentage":_vm.volume},on:{"change-linehead":_vm.onChangeLinehead}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff88ba1c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toefl/audio/components/volume-control.vue
// module id = null
// module chunks = 